import React from 'react'
import '../Services.css'

const Seo = () => {
const serviceData = {
  hero: {
      heading: <>SEARCH ENGINE<br/> OPTIMIZATION</>,
  },
  section1: {
    title: "Your Website is the Hub of your digital marketing Campaigns",
    description:
      <>In today’s hyper-connected digital ecosystem, where nearly every customer journey begins online, Search Engine Optimization (SEO) is more than just a buzzword—it’s the cornerstone of successful, sustainable business growth. An effective SEO strategy ensures your business is discoverable, relevant, and trusted in a crowded marketplace. But what exactly is SEO, why is it essential, and how does it benefit both businesses and their customers? Let’s dive deep into the world of SEO and uncover how it can transform your company’s digital presence and long-term success. <br/>Search Engine Optimization (SEO) is an ever-evolving discipline at the intersection of computer science, linguistics, marketing, and user psychology. Drawing from leading research by PhDs and peer-reviewed literature globally, SEO’s value and complexity continue to deepen as search engines, particularly Google, refine algorithms for relevancy, authority, and user intent.</>,
      title1: "The Key Benefits of SEO for Businesses",
    image: "/seoimg1.webp",
  points: [
      {
        head: "Targeted, High-Quality Traffic",
        text: "Unlike most traditional marketing methods that push messages to uninterested audiences, SEO targets users already looking for what you offer. By aligning your website with the keywords and phrases your customers are searching, you attract relevant prospects actively seeking solutions.",
      },
      {
        head: "Credibility and Brand Trust",
        text: "Websites that rank high in search results are perceived as more credible and authoritative. Consistent SEO efforts—like publishing expert content and earning quality backlinks—build your digital reputation and foster trust with both users and search engines.",
      },
      {
        head: "Cost-Effectiveness",
        text: "While paid ads deliver instant visibility, traffic stops when you stop spending. SEO is a long-term strategy that keeps working for you, providing ongoing traffic and conversions for months or even years after initial optimization, yielding one of the highest ROIs in digital marketing.",
      },
      {
        head: "Better User Experience",
        text: "Effective SEO isn’t just about keywords—it’s about making your site fast, secure, mobile-friendly, and easy to navigate. Search engines reward sites that prioritize user needs, so optimizing for SEO means optimizing for your audience too.",
      },
      {
        head: "Competitive Edge",
        text: "In saturated markets, SEO helps distinguish your brand. Businesses that consistently invest in SEO are more likely to outpace competitors who neglect it, win higher search rankings, and become the go-to choice in their industry.",
      },
    ],
  },
}
  return (
    <>
      {/* Hero Section */}
      <div className="services-hero">
          <div className='seo-hero-img'>
    
          <div className="overlay"></div>
          <div className="hero-content">
            <h2 className="hero_heading">{serviceData.hero.heading}</h2>
            <p className="hero_subheading">{serviceData.hero.subheading}</p>
          </div>
        </div>
        </div>
  

      {/* First Content Section */}
      <div className="backdiv">
      
        <div className="servicepage_grid">
        <div>
  <p className='main_content'>{serviceData.section1.description}</p>
        </div>
          <div>
            <div className="servicepage_imgdiv">
              <img
                src={serviceData.section1.image}
                alt="Web Development"
                className="zweedo_img"
                loading="lazy"
              />
            </div>
          </div>

        </div>
          <div>
             <h2 className='main_heading'>{serviceData.section1.title1}</h2>
             <div className='content_back'>
             <p className='main_content1'> {serviceData.section1.description1} </p>
             </div>
            <div className="servicepage_textdiv">
              {serviceData.section1.points.map((point, index) => (
                  <div key={index} className="service_point">
                    <h4 className="point_head">{point.head}</h4>
                    <p className="point_text">{point.text}</p>
                  </div>
                ))}
            </div>
          </div>
      </div>
    </>
  )
}

export default Seo